
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Announcement/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Announcement/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Flash Sale/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Flash Sale/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Get Subscribers/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Get Subscribers/model.ts';
            var controllerExport2 = _controllerExport2;
            

            
import wrapController3 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller3 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Get Subscribers new/viewer.controller.ts';
            import * as _controllerExport3 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Get Subscribers new/model.ts';
            var controllerExport3 = _controllerExport3;
            

            
import wrapController4 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller4 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Subscribe/viewer.controller.ts';
            import * as _controllerExport4 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Subscribe/model.ts';
            var controllerExport4 = _controllerExport4;
            

            
import wrapController5 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller5 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Teaser/viewer.controller.ts';
            import * as _controllerExport5 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Teaser/model.ts';
            var controllerExport5 = _controllerExport5;
            

            
import wrapController6 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller6 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Timer/viewer.controller.ts';
            import * as _controllerExport6 from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Timer/model.ts';
            var controllerExport6 = _controllerExport6;
            

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://0034666d83aa4c64bed65b479d942481@sentry.wixpress.com/4863',
      id: '0034666d83aa4c64bed65b479d942481',
      projectName: 'promotions-blocks',
      teamName: 'promotions-blocks',
      errorMonitor: true,
    };

  var experimentsConfig = {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"promotions.panel.elements.subtitle_text":"Subtitle","promotions.panel.settings.chooseCampaign.dropdown.connected":"Already in use","promotions.panel.elements.title":"What would you like to display?","promotions.widget.subscribe.demo.title":"Get 20% off your first order","promotions.panel.elements.sign_up_btn":"Sign Up button","promotions.panel.layout.thumbnail.left":"Left","promotions.widget.offer.description.free_shipping":"Free shipping","promotions.widget.announcement.gfpp.mainAction1":"Manage Wix Promos","promotions.widget.offer.description.minimum_order.percent_off":"{amount}{metric} OFF on orders over {currency}{min_offer_amount}","promotions.widget.announcement.demo.subtitle":"Home decor, kitchen essentials and more","promotions.panel.elements.discount_box":"Discount box","promotions.widget.subscribe.demo.disclaimer":"Disclaimer text","promotions.panel.layout.thumbnail.right":"Right","promotions.widget.offer.description.all_products":"All products","promotions.widget.announcement.gfpp.mainAction2":"Settings","promotions.panel.settings.chooseCampaign.dropdown.placeholder":"Choose promo","promotions.panel.settings.emptyState.description":"Set up your first promo that will be linked to this widget on your site.","promotions.widget.subscribe.demo.couponBtn.successState":"COUPONCODE","promotions.panel.elements.content_text":"Content text","promotions.panel.settings.button.label":"Go to BM","promotions.panel.elements.image":"Image","promotions.panel.elements.background_img":"Background image","promotions.widget.announcement.demo.couponBtn":"COUPONCODE","promotions.panel.settings.chooseCampaign.editText.title":"Name your widget","promotions.widget.announcement.label":"Promo widget","promotions.panel.elements.title_text":"Title","widget.global_design.background":"Widget background","promotions.panel.settings.emptyState.exp.description":"{count, plural, one {Extend its end date,} other {Extend the end date of one of your promos,}} or create a new one that will be linked to this widget on your site.","promotions.panel.elements.disclaimer_text":"Disclaimer","promotions.panel.elements.no_thanks_btn":"No Thanks button","promotions.panel.settings.chooseCampaign.dropdown.title":"Choose which promo to show","promotions.widget.subscribe.demo.subtitle.successState":"Enjoy 20% off your first order","promotions.panel.settings.emptyState.exp.buttonLabel2":"Manage Promos","promotions.widget.announcement.demo.disclaimer":"Disclaimer text","promotions.panel.settings.chooseCampaign.editText.placeholder":"Widget name","promotions.panel.layout.label.SideboxContainerPosition":"Container position","promotions.panel.settings.chooseCampaign.richTextLink":"https://support.wix.com/en/article/wix-apps-site-promos","promotions.panel.elements.smallStripLine_text":"Divider","promotions.widget.subscribe.demo.subtitle":"Subscribe now to get exclusive offers and the latest news","promotions.panel.layout.title":"Widget Layout","promotions.panel.settings.chooseCampaign.richTextLabel":"Learn more","promotions.connectedElements.text.editText":"Edit Text","promotions.panel.settings.chooseCampaign.dropdown.empty":"All your promos are currently displayed.","promotions.widget.expired.title":"This promo has ended","promotions.widget.incomplete.title":"This promo is incomplete","promotions.panel.settings.chooseCampaign.richTextContent":"Don't see your promo?","promotions.panel.elements.heading_text":"Heading","promotions.panel.presets.title":"Change Preset","promotions.panel.settings.emptyState.label":"Create your first Wix Promo","promotions.panel.settings.emptyState.buttonLabel":"Create Promo","promotions.widget.subscribe.demo.subscribeCta":"Subscribe","promotions.widget.text_date_from_ms":"{month} {day}, {year}","promotions.widget.expired.subtitle":"\"{promoName}\" is over and no longer appears on your live site. \nExtend its end date in the Dashboard or choose a different promo to show.","promotions.panel.settings.emptyState.exp.buttonLabel":"Create Promo","promotions.connectedElements.stylabeButton.mainAction":"Change Text & Icon","promotions.widget.announcement.demo.heading":"New Arrivals","promotions.widget.incomplete.subtitle":"\"{promoName}\" is missing required info and no longer appears on your live site.","promotions.widget.offer.description.coupon_message":"{amount}{metric}","promotions.widget.announcement.demo.title":"Check out our spring collection","promotions.panel.presets.presetsTitle":"Choose a layout","promotions.widget.offer.description.minimum_order.free_shipping":"Free shipping on orders over {currency}{min_offer_amount}","promotions.widget.offer.description.minimum_order.money_off":"{amount}{currency} OFF on orders over {currency}{min_offer_amount}","promotions.widget.subscribe.demo.disclaimer.successState":"Disclaimer text","promotions.widget.demo.linkBtn":"Shop Now","promotions.widget.subscribe.demo.title.successState":"Thanks for subscribing!","promotions.panel.layout.label.image_position":"Image position","promotions.panel.layout.label.PaddingTopBattom":"Top & bottom padding","promotions.panel.elements.logo_img":"Logo image","promotions.panel.layout.label.PaddingSides":"Side padding","promotions.widget.offer.description.coupon_message_x_y":"Buy {x} and get {y} free","promotions.panel.settings.emptyState.exp.label":"{count, plural, one {Your promo has expired} other {Your promos have expired}}","promotions.panel.settings.chooseCampaign.dropdown.available":"Ready to display","promotions.widget.subscribe.label":"Subscribe Banner"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "promotions-blocks",
    biConfig: null,
    appName: "Promotions",
    appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Announcement/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Announcement",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-t0i9y" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Flash Sale/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Flash Sale",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-p7wgs" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Get Subscribers/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Get Subscribers",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-mad8l" }, { method: controller3,
          wrap: wrapController3,
          exports: controllerExport3,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Get Subscribers new/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Get Subscribers new",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-in4x4" }, { method: controller4,
          wrap: wrapController4,
          exports: controllerExport4,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Subscribe/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Subscribe",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-q8ctu" }, { method: controller5,
          wrap: wrapController5,
          exports: controllerExport5,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Teaser/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Teaser",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-tioc7" }, { method: controller6,
          wrap: wrapController6,
          exports: controllerExport6,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":["bm-apps-7fdf5576-9d52-4c0a-9840-6e226f2ec415"]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/5b0c33aaafa37751/packages/promotions-blocks/src/components/Timer/viewer.controller.ts",
          appName: "Promotions",
          appDefinitionId: "7fdf5576-9d52-4c0a-9840-6e226f2ec415",
          projectName: "promotions-blocks",
          componentName: "Timer",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "7fdf5576-9d52-4c0a-9840-6e226f2ec415-uwffu" }],
    false);

    export const createControllers = _createControllers
